<div [ngClass]="position !=='center' ? 'right-popup' : 'modal-popup'" [style.display] = "showComponent ? 'block' : 'none'">
  <div [class]="'card no-box-shadow modal-dialog' + (size ? ' modal-' + size : '')">
    <div class="card-header bg-gray text-dark">
        {{title}}
      <span class="pull-right cursor-pointer" (click)="closePopup()"><app-icon name="close"></app-icon></span>
    </div>
    <div class="card-body position-relative">
      <ng-content></ng-content>
    </div>
  </div>
</div>